import type { PayloadAction } from "@reduxjs/toolkit";
import type { EditorRootState } from "@v1/store/store";
import type { ProductRef } from "schemas/product";

import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState: { templateEditorProduct: ProductRef | null } = {
  templateEditorProduct: null,
};

const templateReducer = createSlice({
  name: "template",
  initialState,
  reducers: {
    setTemplateEditorProduct: (
      state,
      action: PayloadAction<ProductRef | null>,
    ) => {
      state.templateEditorProduct = action.payload;
    },
  },
});

export const selectTemplateEditorProduct = (state: EditorRootState) => {
  return state.template.templateEditorProduct;
};

export const selectTemplateEditorStoreProduct = createSelector(
  selectTemplateEditorProduct,
  (state: EditorRootState) => state.commerce.products,
  (templateEditorProduct, products) => {
    return templateEditorProduct
      ? products[Number(templateEditorProduct.productId)]
      : undefined;
  },
);

const { reducer, actions } = templateReducer;
export const { setTemplateEditorProduct } = actions;
export default reducer;
